/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_REGIONS = '[Address] Get Regions',
  GET_REGIONS_SUCCESS = '[Address] Get Regions Success',
  GET_REGIONS_FAILED = '[Address] Get Regions Failed',

  GET_PROVINCES = '[Address] Get Provinces',
  GET_PROVINCES_SUCCESS = '[Address] Get Provinces Success',
  GET_PROVINCES_FAILED = '[Address] Get Provinces Failed',

  GET_CITIES = '[Address] Get Cities',
  GET_CITIES_SUCCESS = '[Address] Get Cities Success',
  GET_CITIES_FAILED = '[Address] Get Cities Failed',

  GET_BARANGAYS = '[Address] Get Barangays',
  GET_BARANGAYS_SUCCESS = '[Address] Get Barangays Success',
  GET_BARANGAYS_FAILED = '[Address] Get Barangays Failed',
}

// REGIONS
export const getRegions = createAction(ActionTypes.GET_REGIONS);

export const getRegionsSuccess = createAction(
  ActionTypes.GET_REGIONS_SUCCESS,
  props<{ data: any }>()
);

export const getRegionsFailed = createAction(
  ActionTypes.GET_REGIONS_FAILED,
  props<{ data: any }>()
);

// PROVINCES
export const getProvinces = createAction(
  ActionTypes.GET_PROVINCES,
  props<{ regionId: any }>()
);

export const getProvincesSuccess = createAction(
  ActionTypes.GET_PROVINCES_SUCCESS,
  props<{ data: any }>()
);

export const getProvincesFailed = createAction(
  ActionTypes.GET_PROVINCES_FAILED,
  props<{ data: any }>()
);

// CITIES
export const getCities = createAction(
  ActionTypes.GET_CITIES,
  props<{ provinceId: any }>()
);

export const getCitiesSuccess = createAction(
  ActionTypes.GET_CITIES_SUCCESS,
  props<{ data: any }>()
);

export const getCitiesFailed = createAction(
  ActionTypes.GET_CITIES_FAILED,
  props<{ data: any }>()
);

// BARANGAYS
export const getBarangays = createAction(
  ActionTypes.GET_BARANGAYS,
  props<{ cityId: any }>()
);

export const getBarangaysSuccess = createAction(
  ActionTypes.GET_BARANGAYS_SUCCESS,
  props<{ data: any }>()
);

export const getBarangaysFailed = createAction(
  ActionTypes.GET_BARANGAYS_FAILED,
  props<{ data: any }>()
);
